import {
  createStore
} from 'vuex'
import api from '../utils/api'
import Cookie from 'js-cookie'
export default createStore({
  state: {
      tagsList: [],
      collapse: false,
      groupList: [],
      expvalue:[]
  },
  mutations: {
      delTagsItem(state, data) {
          state
              .tagsList
              .splice(data.index, 1);
      },
      setTagsItem(state, data) {
          state
              .tagsList
              .push(data)
      },
      clearTags(state) {
          state.tagsList = []
      },
      closeTagsOther(state, data) {
          state.tagsList = data;
      },
      closeCurrentTag(state, data) {
          for (let i = 0, len = state.tagsList.length; i < len; i++) {
              const item = state.tagsList[i];
              if (item.path === data.$route.fullPath) {
                  if (i < len - 1) {
                      data
                          .$router
                          .push(state.tagsList[i + 1].path);
                  } else if (i > 0) {
                      data
                          .$router
                          .push(state.tagsList[i - 1].path);
                  } else {
                      data
                          .$router
                          .push("/");
                  }
                  state
                      .tagsList
                      .splice(i, 1);
                  break;
              }
          }
      },
      // 侧边栏折叠
      hadndleCollapse(state, data) {
          state.collapse = data;
      },
      setToken(state, val) {
          state.token = val
          Cookie.set('token', val)
      },
      clearToken(state) {
          state.token = ''
          Cookie.remove('token')
      },
      getToken(state) {
          state.token = Cookie.get('token')
      },
      getexpvalue(state){
          state.expvalue = JSON.parse(localStorage.getItem('expvalue'));
      },
      setfloorlist(state, val) {
          state.groupList = val
          localStorage.setItem('groupList', JSON.stringify(val))
      },
      setexp(state, val){
          state.expvalue = val
          console.log(val);
          localStorage.setItem('expvalue', JSON.stringify(val))
      },
      clearfloorlist(state) {
          state.groupList = [];
          localStorage.removeItem('groupList')
      },
      GetGroup(state,data) {
          // if (localStorage.getItem('groupList') != "undefined" && localStorage.getItem('groupList') != undefined) {
          //     state.groupList = JSON.parse(localStorage.getItem('groupList'))
          // } else {
          //     api.GetGroup().then(res => {
          //         state.groupList = res;
          //         localStorage.setItem('groupList', JSON.stringify(res))
          //     });
          // }
          console.log(data)
          var group=JSON.parse(localStorage.getItem('groupList'));
          state.groupList = group;
          console.log(state.groupList);
      }
  },
  actions: {
      async getgroup({commit}) {
          let result;
              result = await api.GetGroup();
          console.log(result);
          localStorage.setItem('groupList', JSON.stringify(result))
          commit('GetGroup', result)//在这里提交的名字一般大写
      }
  },
  modules: {}
})